<template>
  <div class="tl-list">
    <div class="e-form">
      <TlFilter :filter="filter" @search="searchTls" />
    </div>
    <TlTable ref="table" :items="items" :start="false" @loadMore="loadMore" />
  </div>
</template>
<script>
import TlFilter from "@/default/pages/tls/filter.vue";
import TlTable from "@/default/pages/tls/table.vue";

export default {
  name: "TlList",
  components: {
    TlFilter,
    TlTable,
  },
  data() {
    return {
      filter: {
        pending_operations: true,
      },
      infinite: {
        page: 1,
        loading: false,
        last: false,
      },
      items: [],
    };
  },
  async mounted() {
    await this.loadTls();
    window.TlList = { syncItem: this.syncItem };
    window.addEventListener("container-colorify", this.colorify);
  },
  beforeDestroy() {
    window.removeEventListener("container-colorify", this.colorify);
  },
  computed: {
    vetable() {
      return this.$refs.table.$refs.table;
    },
  },
  methods: {
    async searchTls() {
      this.infinite.page = 1;
      this.infinite.last = false;
      this.items = [];
      await this.loadTls();
    },
    async loadTls() {
      try {
        this.vetable.loading();
        this.infinite.loading = true;
        const q = Object.assign({}, this.filter);
        if (q.status_eq == 4) delete q.undelivered;
        const response = await this.$http.get("/api/v1/tls", {
          params: { q, page: this.infinite.page },
        });
        this.infinite.loading = false;
        const data = response.data;
        const { current_page, page_size, total } = data;
        if (data.tls.length > 0) {
          this.items = this._.concat(this.items, this.processItems(data.tls));
        } else {
          this.infinite.last = true;
        }
        this.vetable.setPagingInfo({
          pageSize: page_size,
          currentPage: current_page,
          total: total,
        });
      } catch (ex) {
        this.infinite.loading = false;
        this.$message({ message: ex.response.data.errors, type: "error" });
      } finally {
        this.vetable.loaded();
      }
    },
    async loadMore() {
      if (!this.infinite.loading && !this.infinite.last) {
        this.infinite.page += 1;
        await this.loadTls();
      }
    },
    processItems(items) {
      return items.map((item) => this.processItem(item));
    },
    processItem(item) {
      item.receivable_invoice_numbers = item.receivable.invoices
        .map((o) => o.number)
        .join(";");
      item.receivable_payment_numbers = item.receivable.payments
        .map((o) => o.number)
        .join(";");
      item.payable_invoice_numbers = item.payable.invoices
        .map((o) => o.number)
        .join(";");
      item.payable_payment_numbers = item.payable.payments
        .map((o) => o.number)
        .join(";");
      return item;
    },
    syncItem(data, action) {
      let index = this.items.findIndex((obj) => obj.id == data.id);
      if (action == "deleted") {
        if (index >= 0) this.items.splice(index, 1);
        return;
      }
      const item = this.processItem(data);
      if (index >= 0) {
        this.items.splice(index, 1, item);
      } else {
        this.items.unshift(item);
      }
    },
    colorify(event) {
      const { id, color } = event.detail;
      const item = this.items.find((item) => item.id === id);
      if (item) this.$set(item, "color", color);
    },
  },
};
</script>
